import IconBase, { IconBaseProps } from "./IconBase";

const GridIconLarge = (props: IconBaseProps) => (
  <IconBase {...props}>
    <g
      transform="translate(1.5 1.5)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    >
      <rect width="17" height="17" rx="2" />
      <path d="M8.5 0v17M0 8.5h17" />
    </g>
  </IconBase>
);

export default GridIconLarge;
